import type { ComponentMetaInput } from '../../ui';

function meta(
  id: string,
  label: string,
  role: ComponentMetaInput['role'],
  y: number,
  height = 44,
): ComponentMetaInput {
  return {
    id: `account.profile.${id}`,
    page: 'settings',
    label,
    role,
    layout: { x: 28, y, width: 334, height },
    zIndex: 102,
    notes: '个人资料编辑弹窗；随内容滚动；资料及读取授权按登录用户 ID 隔离',
  };
}

/** Add this group to the shared manifest generator when integrating the feature. */
export const PROFILE_COMPONENTS: ComponentMetaInput[] = [
  {
    ...meta('backdrop', '个人资料遮罩', 'background', 24, 744),
    layout: { x: 0, y: 24, width: 390, height: 744 },
    zIndex: 100,
  },
  {
    ...meta('dialog', '编辑个人资料', 'modal', 40, 712),
    layout: { x: 12, y: 40, width: 366, height: 712 },
    zIndex: 101,
  },
  meta('title', '个人资料', 'text', 56, 28),
  meta('hint', '个人资料说明', 'text', 92, 44),
  meta('avatar', '选择个人头像', 'input', 140, 44),
  meta('avatar.preview', '个人头像预览', 'icon', 140, 56),
  meta('nickname.label', '昵称标签', 'text', 148, 24),
  meta('nickname', '昵称', 'input', 176),
  meta('birthday.label', '生日标签', 'text', 232, 24),
  meta('birthday', '生日', 'input', 260),
  meta('interests.label', '兴趣爱好标签', 'text', 316, 24),
  meta('interests', '兴趣爱好', 'input', 344),
  meta('bio.label', '个人介绍标签', 'text', 400, 24),
  meta('bio', '个人介绍', 'input', 428, 80),
  meta('consent', '允许智能体读取个人资料', 'input', 520, 44),
  meta('error', '个人资料错误', 'text', 576, 44),
  meta('status', '个人资料保存状态', 'text', 576, 44),
  {
    ...meta('cancel', '关闭个人资料', 'button', 636),
    layout: { x: 28, y: 636, width: 161, height: 44 },
  },
  {
    ...meta('save', '保存个人资料', 'button', 636),
    layout: { x: 201, y: 636, width: 161, height: 44 },
  },
];

export const PROFILE_EDITOR_COMPONENTS = PROFILE_COMPONENTS;

export function profileMeta(id: string): ComponentMetaInput {
  const found = PROFILE_COMPONENTS.find((entry) => entry.id === `account.profile.${id}`);
  if (!found) throw new Error(`未登记的个人资料部件：${id}`);
  return found;
}
